import { useState, useEffect, useCallback } from "react"
import QuoteText from "components/quoteComponents/QuoteText";
import QuoteCheckButton from "components/quoteComponents/QuoteCheckButton";
import QuoteDate from "components/quoteComponents/QuoteDate";
import QuoteList from "components/quoteComponents/QuoteList";
import QuoteGroup from "components/quoteComponents/QuoteGroup";
import QuotePrice from "components/quoteComponents/QuotePrice";
import QuoteSearchBar from "components/quoteComponents/QuoteSearchBar";
import QuoteCustomers from "components/quoteComponents/QuoteCustomers";
import GetPDF from "components/GetPDF";
import api from "api";
import 'styles/quoteedit.css';

const QuoteEdit = (
    {
        selectedQuote, // devis à éditer
        setEditQuote, // flag pour fermer le mode édition
        setReloadQuotes, // flag pour mettre à jour la liste des devis
    }
) => {

    const [ delivery, setDelivery ] = useState(selectedQuote.delivery); // flag pour la livraison
    const [ priced, setPriced ] = useState(selectedQuote.priced); // flag pour les tarifs dans le devis PDF
    const [ event, setEvent ] = useState(selectedQuote.event); // nom de l'événement de devis
    const [ name, setName ] = useState(selectedQuote.name); // nom du client du devis
    const [ phone, setPhone ] = useState(selectedQuote.phone); // téléphone du client du devis
    const [ email, setEmail ] = useState(selectedQuote.email); // email du client du devis
    const [ selectedDates, setSelectedDates ] = useState([]); // liste des dates d'utilisation
    const [ categories, setCategories ] = useState([]); // liste des catégories de matériel
    const [ groups, setGroups ] = useState([]); // liste des groupes
    const [ reload, setReload ] = useState(false); // rechargement d'un équipement du devis
    const [ dataToReload, setDataToReload ] = useState({ 
        category_id : null,
        subCategory_id : null
    }); // données sur l'équipement à recharger
    const [ group, setGroup ] = useState(null); // groupe sélectionné
    const [ enter, setEnter ] = useState(false); // flag pour la touche entrée
    const [ customers, setCustomers ] = useState([]); // liste des clients

    // initialise un équipement à recharger
    const setObjectToReload = (item) => {
        setDataToReload({
            category_id : item.subCategory.category,
            subCategory_id : item.subCategory.id
        });
        setReload(true);
    };

    // coche un paramètre rechargé d'un équipement
    const reloadedData = (field) => {
        setDataToReload((prevData) => {
            const updatedData = {
                category_id: field === 1 ? null : prevData.category_id,
                subCategory_id: field === 2 ? null : prevData.subCategory_id
            };
            const atLeastOneFieldSet = Object.values(updatedData).some(value => value !== null);
            setReload(atLeastOneFieldSet);
            return updatedData;
        });
    };
    const reloadedCategory = () => reloadedData(1);
    const reloadedSubCategory = () => reloadedData(2);  
    
    // charge les dates du devis, les catégories de matériel et la liste des clients
    useEffect(()=>{
        
        api.get(`quote/${selectedQuote.id}/getdates`)
        .then(response => {
            const dates = response.data.map((date) => new Date(date.timestamp));
            setSelectedDates(dates);
        });

        api.get(`categories`)
        .then(response => {
            setCategories(response.data);
        });

        api.get('customers')
        .then(response => {
            setCustomers(response.data);
        });

    },[selectedQuote.id]);
    
    // gère le changement des dates d'utilisation
    const changeDates = (dates) => {
        if (dates.length===0) {
            // eslint-disable-next-line no-restricted-globals
            const response = confirm("SÛR POUR LA SUPPRESSION ?");
            if (!response) return;
            api.delete(`quote/${selectedQuote.id}/del`)
            .then( () => {
                setReloadQuotes(true);
                setEditQuote(false);
            });   
        } else {
            const timestamps = dates.map(date => date.getTime())
            api.put(`quote/${selectedQuote.id}/setdates`, { new_dates : timestamps })
            .then( () => {
                setReloadQuotes(true);
            });
        }
    };
    
    // gère le changement des champs admin du devis (livraison, tél, client, événement)
    const saveQuote = (obj)=>{
        if (Object.keys(obj).every(field => selectedQuote[field] === obj[field])) return;
        api.put(`quote/${selectedQuote.id}/update`, obj)
        .then( () => {
            if ("event" in obj) setReloadQuotes(true);
            Object.assign(selectedQuote, obj);
        });
    };

    // fonction pour quitter le mode édition
    const handleClick = useCallback(() => {
        setEditQuote(false)
    }, [setEditQuote]);
    
    // fonction pour traiter la touche ECHAP
    const handleKey = useCallback((e) => {
        if (e.key === 'Escape') {
            handleClick();
        }
        if (e.key === 'Enter') {
            setEnter(true);
        }
    }, [handleClick]);

    // fonction pour intercepter le clavier
    useEffect(() => {
        document.addEventListener('keydown',handleKey);
        return () => { 
            document.removeEventListener('keydown',handleKey);
        }
    },[handleKey])
    
    return (
        <>
            <div
                className="RentmanClose"
                onClick={handleClick}
            >
                X
            </div>
            <div className="RentmanQuoteEdit">
                <div>
                    <QuoteText
                        variable = {event}
                        setVariable = {setEvent}
                        label = "Projet"
                        onChange={ (data) => { saveQuote({event:data});} }
                    />
                    <QuoteCustomers
                        customers={customers}
                        setName={setName}
                        setPhone={setPhone}
                        setEmail={setEmail}
                        saveQuote={saveQuote}
                        name={name}
                    />
                    <QuoteText
                        variable = {phone}
                        setVariable = {setPhone}
                        label = "Téléphone"
                        onChange={ (data) => { saveQuote({phone:data});} }
                    />
                    <QuoteText
                        variable = {email}
                        setVariable = {setEmail}
                        label = "Email"
                        onChange={ (data) => { saveQuote({email:data});} }
                    />
                    <div
                        className="_3boxes"
                    >
                        <QuoteCheckButton
                            variable = {delivery}
                            setVariable = {setDelivery}
                            label = "LIVRAISON"
                            onChange={ (data) => { saveQuote({delivery:data});} }
                        />
                        <QuoteCheckButton
                            variable = {priced}
                            setVariable = {setPriced}
                            label = "DÉTAIL PDF"
                            onChange={ (data) => { saveQuote({priced:data});} }
                        />
                        <QuoteDate
                            selectedDates = {selectedDates}
                            setSelectedDates = {setSelectedDates}
                            onChange={changeDates}
                        />
                    </div>
                    <div
                        className="_2boxes"
                    >
                        <QuoteGroup
                            quoteid={selectedQuote.id}
                            groups={groups}
                            setGroups={setGroups}
                            setGroup={setGroup}
                        />
                        <div
                            className="QuoteEditIcon"
                        >
                            <span>
                            DEVIS {selectedQuote.id}
                            </span>
                           <GetPDF
                            quoteid={selectedQuote.id}
                           />
                        </div>
                    </div>
                    <QuotePrice
                        quoteid={selectedQuote.id}
                        quotePrice={selectedQuote.user_price}
                        groups={groups}
                        coeff={selectedDates.length}
                        dataToReload={dataToReload}
                        enter={enter}
                        setEnter={setEnter}
                    />
                </div>
                <div>
                    <QuoteSearchBar
                        quoteid={selectedQuote.id} // numéro du devis
                        setObjectToReload={setObjectToReload} // initialise un équipement à recharger
                        group={group} // groupe sélectionné
                        deliveryAdd={false} // ce n'est pas un ajout gratuit à l'enlèvement
                    />
                    {
                        categories
                        &&
                        <QuoteList
                            categories={categories} // liste des catégories
                            quoteid={selectedQuote.id} // numéro du devis
                            reload={reload} // rechargement d'un équipement du devis
                            setObjectToReload={setObjectToReload} // initialise un équipement à recharger
                            reloadedCategory={reloadedCategory} // flag catégorie rechargée
                            reloadedSubCategory={reloadedSubCategory} // flag sous categorie rechargée
                            dataToReload={dataToReload} // données sur l'équipement à recharger
                            groups={groups} // liste des groupes
                            group={group}
                            setGroup={setGroup}
                        />
                    }
                </div> 
            </div>
        </>
        
    )
}

export default QuoteEdit;